import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2021 irfanizudin. All rights reserved.</p>
        </footer>
    );
};

export default Footer;
